import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../services/api";
import { getSession } from "../utils/session";

export default function DepartmentChildBenefits() {
  const [children, setChildren] = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [values, setValues] = useState({});
  const [session, setSession] = useState(null);

  useEffect(() => {
    const s = getSession();
    if (!s) return;

    setSession(s);
    loadChildren(s);
    loadSchemes(s);
    loadSaved(s);
  }, []);

  /* Load children */
  const loadChildren = async (s) => {
    const res = await api.get(`/children/block/${s.block_id}`);
    setChildren(res.data);
  };

  /* Load schemes */
  const loadSchemes = async (s) => {
    const res = await api.get(`/data/schemes/${s.department_id}`);
    setSchemes(res.data);
  };

  /* Load saved benefits */
  const loadSaved = async (s) => {
    const res = await api.get(
      `/benefits?block=${s.block_id}&department=${s.department_id}`
    );

    const temp = {};

    res.data.forEach((r) => {
      const key = `${r.child_id}_${r.scheme_id}`;
      temp[key] = true;
    });

    setValues(temp);
  };

  /* Toggle */
  const toggle = (childId, schemeId) => {
    const key = `${childId}_${schemeId}`;

    setValues((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  /* Save */
  const save = async () => {
    const payload = [];

    Object.keys(values).forEach((key) => {
      if (values[key]) {
        const [childId, schemeId] = key.split("_");

        payload.push({
          child_id: childId,
          scheme_id: schemeId,
          department_id: session.department_id,
          block_id: session.block_id,
        });
      }
    });

    await api.post("/benefits/save", payload);

    alert("Saved successfully");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-7xl mx-auto p-6">
        <h2 className="text-2xl font-bold mb-4">
          Department Benefit Selection
        </h2>

        <div className="overflow-auto bg-white shadow rounded">
          <table className="min-w-full">
            <thead className="bg-gray-200">
              <tr>
                <th className="p-2">Child</th>
                <th className="p-2">Mother</th>
                <th className="p-2">Village</th>

                {schemes.map((s) => (
                  <th key={s.id} className="p-2">
                    {s.name}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {children.map((child) => (
                <tr key={child.id} className="border-t">
                  <td className="p-2">{child.child_name}</td>
                  <td className="p-2">{child.mother_name}</td>
                  <td className="p-2">{child.village}</td>

                  {schemes.map((s) => {
                    const key = `${child.id}_${s.id}`;

                    return (
                      <td key={s.id} className="text-center">
                        <input
                          type="checkbox"
                          checked={values[key] || false}
                          onChange={() => toggle(child.id, s.id)}
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <button
          onClick={save}
          className="mt-4 bg-blue-600 text-white px-6 py-2 rounded"
        >
          Save
        </button>
      </div>
    </div>
  );
}